module.exports = __webpack_public_path__ + "img/kaoshipass.4d5762ad.png";